import { SectionData, NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Inicio', href: '#section1' },
  { label: 'Bagels', href: '#section2' },
  { label: 'Café', href: '#section3' },
  { label: 'Catering', href: '#section7' },
  { label: 'Horarios', href: '#section8' },
  { label: 'Fresh Energy', href: '#section4b' },
  { label: 'Snacks', href: '#section4' },
  { label: 'Mercancía', href: '#section5' },
  { label: 'About', href: '#section6' },
  { label: 'Contacto', href: '#footer' }
];

export const sections: SectionData[] = [
  {
    id: 'section1',
    eyebrow: 'Breakfast bodega energy',
    title: 'Bienvenido a Tegus Bagel Co.',
    description: '¡Empieza tu mañana al estilo bagel! Desplácese hacia abajo para ver opciones deliciosas...',
    backgroundImage: '/images/bagel-background.jpeg',
    floatingCharacters: [
      { src: '/images/BLUEBERRY.png', alt: 'blueberry', className: 'floating-1' },
      { src: '/images/STRAWBERRY.png', alt: 'strawberry', className: 'floating-2' },
      { src: '/images/avocado.png', alt: 'avocado', className: 'floating-3' },
      { src: '/images/BLUEBERRY2.png', alt: 'blueberry accent', className: 'floating-12' }
    ]
  },
  {
    id: 'section2',
    eyebrow: 'Build your favorite',
    title: 'Bagels y aderezos',
    description: 'Elija entre una variedad de bagels frescos y deliciosos aderezos para satisfacer sus antojos.',
    backgroundImage: '/images/toppings-background.jpg',
    floatingCharacters: [
      { src: '/images/egg.png', alt: 'egg', className: 'floating-4' },
      { src: '/images/peanutbutter.png', alt: 'peanut butter', className: 'floating-5' }
    ]
  },
  {
    id: 'section3',
    eyebrow: 'Coffee + bagel combos',
    title: 'Combinaciones de desayuno',
    description: '¡Combina tus bagels con una bebida refrescante o una taza de café caliente!',
    backgroundImage: '/images/coffee-background.jpg',
    floatingCharacters: [
      { src: '/images/NUTELLA.png', alt: 'nutella', className: 'floating-6' },
      { src: '/images/citrus.png', alt: 'citrus', className: 'floating-7' },
      { src: '/images/STRAWBERRY2.png', alt: 'strawberry accent', className: 'floating-13' }
    ]
  },
  {
    id: 'section7',
    eyebrow: 'Feed a crowd',
    title: 'Catering para oficinas, brunches y reuniones con hambre de NY.',
    description: 'Armamos pedidos grandes con bagels por docena, schmears, desayunos completos y café para oficinas, equipos y brunches privados. Si quieres algo especial, lo coordinamos directo contigo.',
    activeOffsetY: '-22px',
    backgroundImage: '/images/toppings-background.jpg',
    floatingCharacters: [
      { src: '/images/egg2.png', alt: 'egg accent', className: 'floating-4' },
      { src: '/images/ROUND EGG.png', alt: 'round egg accent', className: 'floating-13' },
      { src: '/images/JAM.png', alt: 'jam accent', className: 'floating-11' }
    ],
    hasTextBackground: true,
    highlights: [
      'Desayunos corporativos y brunch kits listos para compartir.',
      'Docenas de bagels, schmears y café en un solo pedido.'
    ],
    ctaLabel: 'Solicitar catering',
    ctaHref: 'https://forms.gle/replace-with-your-google-form',
    ctaExternal: true
  },
  {
    id: 'section8',
    eyebrow: 'Hours + delivery',
    title: 'Operamos como una ghost kitchen enfocada en velocidad, consistencia y una experiencia diferente para Tegucigalpa.',
    description: '',
    activeOffsetY: '-26px',
    backgroundImage: '/images/bagel-background.jpeg',
    floatingCharacters: [
      { src: '/images/FORK.png', alt: 'fork accent', className: 'floating-12' },
      { src: '/images/BLUEBERRY3.png', alt: 'blueberry accent', className: 'floating-14' }
    ],
    hasTextBackground: true,
    highlights: [
      'Breakfast: 6am - 11am',
      'Lunch: 11am - 4pm',
      'Dinner: 4pm - 10pm'
    ]
  },
  {
    id: 'section4b',
    eyebrow: 'Clean fuel options',
    title: 'Opciones frescas para una mañana más ligera.',
    description: 'También tenemos picks pensados para quienes buscan algo más balanceado sin perder sabor ni energía para arrancar el día.',
    activeOffsetY: '-12px',
    backgroundImage: '/images/coffee-background.jpg',
    floatingCharacters: [
      { src: '/images/BLUEBERRY.png', alt: 'blueberry accent', className: 'floating-1' },
      { src: '/images/STRAWBERRY2.png', alt: 'strawberry accent', className: 'floating-13' },
      { src: '/images/avocado.png', alt: 'avocado accent', className: 'floating-3' }
    ],
    hasTextBackground: true,
    highlights: [
      'Overnight oats, fruit cups y opciones que se sienten fresh de verdad.',
      'Breakfast bagels con ingredientes que te dan energía más limpia y natural.',
      'Ideal para un desayuno más ligero sin salirte del antojo.'
    ]
  },
  {
    id: 'section4',
    eyebrow: 'Sweet and salty extras',
    title: 'Snacks y Postres',
    description: '¿Tienes antojos de algo dulce por la mañana? Disfruta de nuestros deliciosos snacks y postres para un rápido impulso de energía o para satisfacer tus antojos.',
    backgroundImage: '/images/snacks.jpg',
    floatingCharacters: [
      { src: '/images/MUNCH.png', alt: 'munch', className: 'floating-8' },
      { src: '/images/tocino.png', alt: 'tocino', className: 'floating-9' }
    ]
  },
  {
    id: 'section5',
    eyebrow: 'Wear the vibe',
    title: 'Mercancía Tegus Bagel Co.',
    description: '¡Llévate contigo el universo de Los Schmearables! Descubre nuestra increíble colección de mercancía, desde llaveros con forma de bagel hasta camisetas, arte para tu pared y mucho más. ¡Convierte tu amor por los bagels en estilo!',
    backgroundImage: '/images/merch.png',
    floatingCharacters: [
      { src: '/images/nutellacarton.png', alt: 'nutella carton', className: 'floating-10' },
      { src: '/images/JAM.png', alt: 'jam', className: 'floating-11' },
      { src: '/images/BLUEBERRY3.png', alt: 'blueberry accent', className: 'floating-14' }
    ],
    hasTextBackground: true
  },
  {
    id: 'section6',
    eyebrow: 'About us',
    title: 'De las bodegas de New York a Tegucigalpa.',
    description: 'Me mudé a New York cuando tenía 8 años y desde entonces me quedé con la vibra de las bodegas, el bacon egg and cheese antes de la escuela y el ritmo rápido de la mañana. Tegus Bagel Co. nace para traer esa energía a Tegucigalpa y convertirla en una experiencia de breakfast con actitud neoyorquina.',
    backgroundImage: '/images/coffee-background.jpg',
    floatingCharacters: [
      { src: '/images/BLUEBERRY2.png', alt: 'blueberry accent', className: 'floating-12' },
      { src: '/images/citrus.png', alt: 'citrus accent', className: 'floating-7' }
    ],
    hasTextBackground: true,
    highlights: [
      'Corner bodega breakfast energy, ahora en Tegucigalpa.',
      'La ghost kitchen con un concepto distinto y bien definido.'
    ]
  }
];
